import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.013 2.969v1.10411c-.7296.11445-1.41558.36036-2.03294.71274l8.99384 8.99375c-.0159-.1442-.0239-.29-.0239-.4365v-3.092c0-3.00745-2.1222-5.66286-5-6.16532V2.969c0-.535-.434-.969-.969-.969-.535 0-.968.434-.968.969zM20.3659 19.0001L7.42544 6.05965l-.00074.00084L3.41421 2.05 2 3.46421l4.35768 4.35768C6.09445 8.49711 5.95 9.23173 5.95 10.0001v3.343c0 1.061-.421 2.078-1.172 2.828l-1.828 1.829v1h14.5859l2.9903 2.9903 1.4142-1.4142-1.5761-1.5761h.0016z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.95 22c-1.105 0-2-.895-2-2h4c0 1.105-.895 2-2 2z",
    fill: "currentColor"
  }));
});